<script setup lang="ts">
import ModalAlert from '@/components/current-student-advanced-standing-form/shared/ModalAlert.vue'
import type { AlertTone } from '@/models/current-student-advanced-standing-form/modalAlert'

defineProps<{
  shown: boolean
  active: boolean
  message: string
  errorMessage: string
  alertTone: AlertTone
}>()

const emit = defineEmits<{
  cancel: []
  delete: []
}>()
</script>

<template>
  <div
    class="modal fade"
    id="ConfirmDeleteModal"
    :class="{ show: shown }"
    :style="{ display: active ? 'block' : 'none' }"
    role="dialog"
    aria-modal="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Confirm Delete</h4>
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
          <ModalAlert alert-id="ConfirmDeleteModalError" :alert-tone="alertTone" :message="errorMessage" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="emit('cancel')">Cancel</button>
          <button type="button" class="btn btn-danger" id="DeleteBtn" @click="emit('delete')">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>
